module.exports = __webpack_public_path__ + "static/img/tj4.c6d2d66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tj4.png
// module id = UsOn
// module chunks = 0